module.exports = __webpack_public_path__ + "static/media/20190805_50Days2019_Tag01_0041AT.cdae4a1a.jpg";